<nav class="navbar navbar-expand-lg navbar-light">
  <div class="container">
    <a class="navbar-brand" href="/"><img src="../../../../assets/images/KlickitLogoWithoutSlogan.svg" /></a>

    <ul class="navbar-nav nav1 mr-auto">
      <li [ngClass]="parameterValue == '/' ? 'nav-item active' : 'nav-item'">
        <a class="nav-link" (click)="onSwitchPage('business')">Business</a>
        <div class="bottomline"></div>
      </li>
      <li [ngClass]="
          parameterValue == 'individual' ? 'nav-item active' : 'nav-item'
        ">
        <a class="nav-link" (click)="onSwitchPage('individual')">Individual</a>
        <div class="bottomline"></div>
      </li>
    </ul>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto"></ul>

      <ul class="navbar-nav my-2 my-lg-0">
        <!-- <li class="nav-item">
          <a class="nav-link" href="/comingsoon">Pricing</a>
        </li> -->
        <!-- <li class="nav-item">
          <a
            [ngClass]="
              parameterValue == 'aboutus' ? 'nav-link activeNl' : 'nav-link'
            "
            href="/aboutus"
            >About Us</a
          >
        </li> -->
        <!-- <li class="nav-item">
          <a          [ngClass]="
          parameterValue == 'contactus' ? 'nav-link activeNl' : 'nav-link'
        " href="/contactus">Contact Us</a>
        </li> -->
        <!-- <li class="nav-item">
          <a class="nav-link" href="/comingsoon">Success Stories</a>
        </li> -->
        <li class="nav-item dropdown">
          <div [ngClass]="
          parameterValue == 'aboutus' || parameterValue == 'blog'  ? 'activeNl' : ''
        " class="nav-link dropdown-toggle" href="#" id="nxx" role="button" data-bs-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            Company
            <div class="iconDd"></div>
          </div>
          <div class="dropdown-menu" aria-labelledby="nxx">
            <a class="dropdown-item" href="/aboutus">About Us</a>
            <a class="dropdown-item" href="/blog">Blog</a>
            <!-- <a class="dropdown-item" href="/comingsoon">Meet The Team</a> -->
            <!-- <a class="dropdown-item" href="/contactus">Contact Us</a> -->
          </div>
        </li>

        <li class="nav-item">
          <a [ngClass]="
          parameterValue == 'contactus' ? 'nav-link activeNl' : 'nav-link'
        " href="/contactus">Contact Us</a>
        </li>

        <!-- <li class="nav-item lang webheader">
          <img
            id="langImg"
            class="langImg"
            src="../../../assets/images/globe.asia.australia.svg"
            alt="Globe"
          />
          <span class="langText" style="cursor: pointer">EN </span>
          <a
            href="comingsoon"
            target="_blank"
            class="langText"
            style="cursor: pointer"
          >
            AR</a
          >

          <div class="langImg"></div>
        </li> -->
      </ul>
    </div>
  </div>
</nav>